// Native (Capacitor) detection + auth-token storage. On the web this is inert
// (isNative === false); in the app it holds the Sanctum Bearer token, since the
// session cookie can't cross the capacitor:// → api.lakaycart.com origin.

import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

export const isNative = Capacitor.isNativePlatform();

const TOKEN_KEY = 'lakaycart_token';
let cached: string | null | undefined = undefined;   // undefined = not loaded yet

/** Load (and memoize) the stored token. Returns null on web or when signed out. */
export async function loadToken(): Promise<string | null> {
  if (!isNative) return null;
  if (cached !== undefined) return cached;
  const { value } = await Preferences.get({ key: TOKEN_KEY });
  cached = value ?? null;
  return cached;
}

export async function setToken(token: string): Promise<void> {
  cached = token;
  if (isNative) await Preferences.set({ key: TOKEN_KEY, value: token });
}

export async function clearToken(): Promise<void> {
  cached = null;
  if (isNative) await Preferences.remove({ key: TOKEN_KEY });
}
